import { Injectable } from '@angular/core';
import { BasePersistentStorage } from '@ebeihilfe/core';

@Injectable({
  providedIn: 'root',
})
export class WebPreferencesImpl implements BasePersistentStorage {
  public getValue(key: string): Promise<string | null> {
    const result = localStorage.getItem(key);
    return Promise.resolve(result);
  }

  public setValue(key: string, value: string): Promise<void> {
    localStorage.setItem(key, value);
    return Promise.resolve();
  }

  public removeValue(key: string): Promise<void> {
    localStorage.removeItem(key);
    return Promise.resolve();
  }
}
